var $ = require('jquery');
var lottie = require('./libs/lottie.min.js');
var matchHeight = require('./libs/matchheight.js');
var Cookies = require('js-cookie');
var scrollMonitor = require('scrollmonitor');
var objectFit = require('object-fit-images');
var fitvids = require('fitvids');

var heroLottie;

if (!Cookies.get('init-animation') && $('body').hasClass('home')) {
    Cookies.set('init-animation', 1);
    $('.site-header, .hero--type-animation .hero__content, .hero--type-animation .hero__animation').addClass('is-transitionable is-visible');
} else {
    $('.site-header, .hero--type-animation .hero__content, .hero--type-animation .hero__animation').addClass('is-visible');
}

$(document).ready(function () {
    initHero();
    if ($('body').hasClass('init-animation')) {
        setTimeout(function () {
            $('body').removeClass('init-animation');
            heroLottie.play();
        }, 1500);
    } else {
        heroLottie.play();
    }

    initNav();
    initAnimation();

    // libs
    // initMatchHeight();
    objectFit();
    fitvids('.basic-content');

    let stickyObj = new Sticky('#map .facetwp-facet-map');
});

(function ($) {
    var $ = jQuery;
    $(document).on('facetwp-loaded', function () {
        $('.card--surgeon').addClass('animate');
        scrollToNewFacets();
    });
})(jQuery);

function scrollToNewFacets() {
    $('.facetwp-page').on('click', function () {
        $('html, body').animate({
            scrollTop: $('.facetwp-facet-surgeon_result_total').offset().top - 25,
        })
    })
}


function initHero() {
    if ($('#hero__animation-container').attr('data-json') !== '') {
        var animationFile = $('#hero__animation-container').attr('data-json');
        heroLottie = lottie.loadAnimation({
            container: document.getElementById('hero__animation-container'),
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: animationFile,
            // rendererSettings: {
            //     scaleMode: '1',
            // }
        });
    }
}

function initNav() {
    $('.site-header__mobile-toggle').on('click', function () {
        $(this).find('.hamburger').toggleClass("is-active");
        $('.site-header').toggleClass('active');
        if (!$('.site-header').hasClass('active')) {
            $('.menu-item.active-submenu').removeClass('active-submenu');
        }
    })

    // $('.menu-item.menu-item-has-children').on("click", function () {
    //     if ($(this).hasClass('active-submenu')) {
    //         $(this).children('.sub-menu')
    //             .stop()
    //             .slideUp(1000);
    //     } else {
    //         $('.menu-item.active-submenu').removeClass('active-submenu');
    //     }

    //     $(this).toggleClass('active-submenu');
    //     if ($(this).hasClass("active-submenu")) {
    //         $(this).children('.sub-menu')
    //             .stop()
    //             .slideDown(1000);
    //     }
    // })

    let desktop = false,
        mobile = false;

    if ($(window).width() > 767) {
        $("#menu-main-menu .menu-item-has-children").hover(
            function () {
                console.log('hover event');
                $(this).children('.sub-menu')
                    .stop()
                    .slideDown(100);
            },
            function () {
                $(this).children('.sub-menu')
                    .stop()
                    .slideUp(100);
            }
        );
    } else {
        $("#menu-main-menu .menu-item-has-children").on('click', function (e) {
            e.stopPropagation();
            $(this).toggleClass('active-submenu');
            if ($(this).hasClass('active-submenu')) {
                $(this).children('.sub-menu')
                    .stop()
                    .slideDown(100);
            } else {
                $(this).children('.sub-menu')
                    .stop()
                    .slideUp(100);
            }
        });
    }


    // $(window).on('resize', function () {
    //     if ($(window).width() > 767) {
    //         if (!desktop) {
    //             console.log('here--desktop');
    //             desktop = true;
    //             mobile = false;
    //             desktopEvent;
    //         }
    //         $("#menu-main-menu li").unbind("click");
    //     } else {
    //         if (!mobile) {
    //             console.log('here--mobile');
    //             mobile = true;
    //             desktop = false;
    //             mobileEvent;
    //         }
    //         $("#menu-main-menu li").unbind("mouseenter mouseleave");
    //     }
    // }).trigger('resize');
}

function initAnimation() {

    $('.hero--type-default').each(function () {
        let _this = $(this);
        let hero = scrollMonitor.create(_this);
        hero.enterViewport(function () {
            _this.addClass('animate-in')
        })
    })

    $('.benefits--data').each(function () {
        let _this = $(this);
        let dataPoints = scrollMonitor.create(_this, -75);
        dataPoints.enterViewport(function () {
            stagger(_this, '.benefits__block');
        })
    })

    $('.content-with-visual').each(function () {
        let _this = $(this);
        let contentWithVisual = scrollMonitor.create(_this, -75);
        contentWithVisual.enterViewport(function () {
            _this.find('.content-with-visual__visual').addClass('fade-in');
            _this.addClass('animate');
        })
    })

    $('.card').each(function () {
        let _this = $(this);
        let cards = scrollMonitor.create(_this);
        cards.enterViewport(function () {
            _this.addClass('animate');
        })
    })

    $('.wysiwyg-content').each(function () {
        let _this = $(this);
        let wysiwyg = scrollMonitor.create(_this);
        wysiwyg.enterViewport(function () {
            _this.find('img').addClass('fade-in');
        })
    })


    function stagger(parent, item) {
        let items = parent.find(item);
        let timer = 0;

        items.each(function (index) {
            if (index == 0) {
                $(this).addClass("animate");
            }
            animate($(this));
            timer += 175;
        });

        function animate(target) {
            setTimeout(function () {
                target.addClass("animate");
            }, timer);
        }
    }
}

function initMatchHeight() {
    let listings = ['.article-listing', '.patient-stories', '.page-listing', '.post-listing__list'];
    $(listings).each(function () {
        let multiSameListing = $(this);
        multiSameListing.each(function () {
            let cards = $(this).find('.card');
            if ($(this).hasClass('page-listing')) {
                cards = $(this).find('.card__content')
            }
            cards.matchHeight({
                byRow: false
            });
        })
    })
}

$(document).on('resize', function () {
    initMatchHeight();
}).trigger('resize');